export default "__VITE_ASSET__jDa9wY56__"